import Stack from '@mui/material/Stack'
import AuthCardWrapper from 'auth/shared/AuthCardWrapper'
import { observer } from 'mobx-react-lite'
import { useAuthStore } from '../AuthStore'
import useStore from 'reusable/mobx-store-utils'
import AuthForgotPasswordStore from './AuthForgotPasswordStore'
import CenterFullScreen from 'reusable/mui/utilities/CenterFullScreen'
import onEnterProp from 'reusable/utils/on-enter-prop'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import TextFieldEmail from 'reusable/mui/text-field-email/TextFieldEmail'
import GapLink from 'reusable/mui/links/GapLink'

export default observer(function AuthForgotPassword() {
   const authStore = useAuthStore()
   const authForgotPasswordStore = useStore(() => new AuthForgotPasswordStore({ authStore }))

   return <CenterFullScreen>
      <AuthCardWrapper title="Forgot Password">
         {authForgotPasswordStore.hasBeenSent && (
            <Stack spacing={3}>
               <Typography variant='body1'>
                  A password reset code has been sent to your email. Please check your inbox.
               </Typography>
            </Stack>
         )}
         {!authForgotPasswordStore.hasBeenSent && (
            <Stack spacing={3}>
               {authForgotPasswordStore.formHandler.email.bindInput(ip =>
                  <TextFieldEmail
                     autoFocus
                     fullWidth
                     label="Email*"
                     {...onEnterProp(authForgotPasswordStore.sendForgotPassword)}
                     ip={ip}
                  />)}
               <ButtonWithProgress
                  loading={authForgotPasswordStore.loader.isLoading}
                  variant="contained"
                  onClick={authForgotPasswordStore.sendForgotPassword}>
                  Send password reset email
               </ButtonWithProgress>
               <Divider>
                  <Typography variant='overline'>or</Typography>
               </Divider>
               <GapLink variant="body2" onClick={authStore.navigateToSignIn} sx={{ alignSelf: 'center' }} underlineStyle="dashed">
                  Log in
               </GapLink>
            </Stack>
         )}
         {authForgotPasswordStore.hasBeenSent && <>
            <Divider>
               <Typography variant='overline'>or</Typography>
            </Divider>
            <Box
               sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  gap: 1
               }}
            >
               <GapLink variant="body2" onClick={authStore.navigateToSignIn} underlineStyle="dashed">
                  Log in
               </GapLink>
               <Typography variant="body2">|</Typography>
               <GapLink variant="body2" onClick={authForgotPasswordStore.sendForgotPassword} underlineStyle="dashed">
                  Resend email
               </GapLink>
            </Box>
         </>}
      </AuthCardWrapper>
   </CenterFullScreen>
})
